import { render, staticRenderFns } from "./workParameter.vue?vue&type=template&id=a4b9a6ca&scoped=true&"
import script from "./workParameter.vue?vue&type=script&lang=js&"
export * from "./workParameter.vue?vue&type=script&lang=js&"
import style0 from "./workParameter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./workParameter.vue?vue&type=style&index=1&id=a4b9a6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b9a6ca",
  null
  
)

export default component.exports